import React, { useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Button,
} from "@mui/material";
import { server } from "../../../common";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { useSelectAccess } from "../../../store/stateFunctions";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";

// const initialValues = {
//   name: "",
//   contactno: "",
//   email: "",
//   college_name: "",
//   education: "",
//   year: "",
// };

const EditIndustryProfile = () => {
  const user = useSelectAccess("Industry User");
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      organization_name: "",
      org_contact: "",
      business_email: "",
      org_type: "",
    },
    validationSchema: yup.object({
      organization_name: yup.string().required("Enter your Full Name"),
      org_contact: yup
        .string()
        .matches(/^\d{10}$/, "Enter a valid 10-digit contact number")
        .required("Enter your Contact Number"),
      business_email: yup.string().email("Enter a valid Email"),
      org_type: yup.string().required("Select organization type"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        setSubmitting(true);
        const response = await server.put(
          "/register/updateorganization",
          values,
          {
            headers: {
              Authorization: user.authToken,
            },
          }
        );
        toast.success("Profile updated successfully");
        navigate("/industryprofile");
      } catch (error) {
        if (error instanceof AxiosError && error.response?.data?.message) {
          toast.error(error.response.data.message);
        } else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else {
          toast.error("Failed to update profile");
        }
      } finally {
        setSubmitting(false);
      }
    },
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await server.get("/register/organizationprofile", {
          headers: {
            Authorization: user.authToken,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        formik.setValues(response.data);
      } catch (error) {
        if (error.response?.status === 401) {
          navigate("/loginorg");
        }
        console.error("Error fetching user data:", error);
      }
    };

    if (!formik.values.name) {
      fetchData();
    }
  }, [formik.values.name, navigate, user.authToken, formik.setValues]);

  return (
    <div>
      <div className="container mb-5">
        <div className="row">
          <div className="col">
            <form
              className="needs-validation d-flex flex-column gap-3"
              onSubmit={formik.handleSubmit}
            >
              <div className="card">
                <h5 className="p-3 fs-5 data-name  mb-0">Personal Details</h5>
                <div className="row px-5">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <TextField
                        name="organization_name"
                        type="text"
                        value={formik.values.organization_name}
                        onChange={formik.handleChange}
                        placeholder="Lorem"
                        variant="outlined"
                        label="Full Name"
                        fullWidth
                        required
                      ></TextField>
                    </div>

                    <div className="col-md-6 mb-3">
                      <TextField
                        name="org_contact"
                        type="number"
                        value={formik.values.org_contact}
                        onChange={formik.handleChange}
                        placeholder="9876789087"
                        variant="outlined"
                        label="Contact Number"
                        disabled
                        fullWidth
                        required
                      ></TextField>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <TextField
                        name="business_email"
                        type="email"
                        value={formik.values.business_email}
                        onChange={formik.handleChange}
                        placeholder="loremipsum@gmail.com"
                        variant="outlined"
                        label="Email"
                        disabled
                        fullWidth
                        required
                      ></TextField>
                    </div>
                    <div className="col-md-6 mb-2">
                      <FormControl fullWidth required>
                        <InputLabel id="demo-simple-select-label">
                          Type
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Year"
                          variant="outlined"
                          name="org_type"
                          value={formik.values.org_type}
                          onChange={formik.handleChange}
                          required
                        >
                          <MenuItem value="nonprofit">Nonprofit </MenuItem>
                          <MenuItem value="government">Government</MenuItem>
                          <MenuItem value="business">Business</MenuItem>
                          <MenuItem value="consultant">Consultant</MenuItem>
                          <MenuItem value="recruiter">Recruiter</MenuItem>
                          <MenuItem value="community group/association">
                            Association/Community Group
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </div>
              </div>

              <hr />
              <button
                type="submit"
                className="banner p-2 text-white rounded-3 border-0"
              >
                Save
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditIndustryProfile;
